<template>
  <FlotoModule>
    <template v-if="hasPermission">
      <RouterView :key="$route.fullPath" />
    </template>
  </FlotoModule>
</template>

<script>
import { PreferenceComputed } from '@state/modules/preference'
import { LicenseComputed } from '@state/modules/license'

export default {
  name: 'RolesModule',
  page() {
    return {
      title: this.$tc('role'),
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (
        vm.$route.query.moduleName === vm.$constants.PROJECT &&
        !vm.hasProjectRequesterLicense
      ) {
        return vm.$router.replace({ name: '404' })
      }

      if (
        vm.$route.query.moduleName !== vm.$constants.PROJECT &&
        vm.myAllowedModules.indexOf('admin.user.users_roles') === -1
      ) {
        return vm.$router.replace({ name: '404' })
      }
    })
  },
  data() {
    return {
      hasPermission: false,
    }
  },
  computed: {
    ...PreferenceComputed,
    ...LicenseComputed,
  },
  created() {
    if (
      this.$route.query.moduleName === this.$constants.PROJECT &&
      !this.hasProjectRequesterLicense
    ) {
      return this.$router.replace({ name: '404' })
    }

    if (
      this.$route.query.moduleName !== this.$constants.PROJECT &&
      this.myAllowedModules.indexOf('admin.user.users_roles') === -1
    ) {
      return this.$router.replace({ name: '404' })
    }

    if (
      this.$route.query &&
      this.$route.query.moduleName &&
      [this.$constants.PROJECT].indexOf(this.$route.query.moduleName) < 0
    ) {
      return this.$router.replace({ name: '404' })
    }

    this.hasPermission = true
  },
}
</script>
